import { isLocallyServed } from './runtimeUtils';
import { storageManager } from './storageUtils';

export const loggingStorage = storageManager.createOrFetchStorage<boolean>('loggingEnabled');

/**
 * Checks if logging is enabled: the env variable, unless this session is served locally,
 * with the storage key overriding both.
 */
export const isLoggingEnabled = () =>
  loggingStorage.get() ?? (process.env.REACT_APP_FEATURE_LOGGING_ENABLED === 'true' && !isLocallyServed());

export const isLoggingEnabledLocally = () => isLoggingEnabled() && isLocallyServed();

/**
 * Disables logging and reloads the page.
 */
export const disableLogging = () => {
  loggingStorage.set(false);
  globalThis.location.reload();
};
